import React from "react";
import { ErrorPageDoorExitIcon } from "../Icons/ErrorPageDoorExitIcon";
import { ErrorPageWrapper } from "./ErrorPageWrapper";
import { useErrorIconSize } from "../Icons/ErrorIconSize";

/**
 * Shown when
 * - the teacher has ended the lesson (all users left)
 * - the student leaves the call manually
 */
export const LeftCallPage = (): JSX.Element => {
    const iconSize = useErrorIconSize();
    return (
        <ErrorPageWrapper
            icon={<ErrorPageDoorExitIcon size={iconSize}/>}
            title={'Du hast den Unterricht verlassen.'}
            content=""
        />
    );
}
